import React from 'react';

const PlaceholderUploadFile = ({ size = 40, fill = '#D3D2D2' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 41 37"
      fill="none"
    >
      <path
        d="M20.828 36.1215C14.9685 36.1215 9.10895 36.1215 3.2494 36.1215C2.96317 36.1215 2.67323 36.1215 2.38577 36.0919C0.918823 35.9549 0.329085 34.9667 0.954602 33.6305C1.49746 32.4769 2.08966 31.353 2.6646 30.2117C5.37887 24.8383 8.09315 19.4657 10.8074 14.0939C10.8913 13.9298 10.9789 13.7657 11.0764 13.609C11.7599 12.5134 12.8703 12.3592 13.745 13.3043C14.3619 13.9656 14.8838 14.7083 15.434 15.4251C18.2306 19.0795 21.0271 22.7356 23.8236 26.3933C25.045 27.9848 26.5835 28.0712 28.0184 26.64C28.7303 25.9294 29.4261 25.2002 30.1467 24.4957C31.4458 23.225 32.9201 23.3014 33.9812 24.7832C36.1107 27.7566 38.1871 30.7694 40.2734 33.7724C40.4364 34.008 40.5613 34.2678 40.6435 34.5423C40.8458 35.2319 40.5596 35.7871 39.8601 35.9709C39.4214 36.076 38.9711 36.1245 38.5202 36.1153C32.6261 36.1252 26.7287 36.1272 20.828 36.1215Z"
        fill={fill}
      />
      <path
        d="M33.9688 6.67775C33.9673 7.82467 33.6253 8.94532 32.9861 9.89763C32.347 10.8499 31.4394 11.591 30.3786 12.0269C29.3177 12.4628 28.1513 12.5739 27.0272 12.3461C25.9032 12.1183 24.872 11.5618 24.0646 10.7473C23.2572 9.93272 22.7098 8.89677 22.4918 7.77074C22.2739 6.64472 22.3951 5.47934 22.8403 4.42233C23.2855 3.36533 24.0345 2.46431 24.9924 1.83351C25.9502 1.2027 27.0738 0.870516 28.2207 0.879067C29.7479 0.898475 31.2064 1.51722 32.2816 2.60193C33.3569 3.68664 33.9628 5.15043 33.9688 6.67775Z"
        fill={fill}
      />
    </svg>
  );
};

export default PlaceholderUploadFile;
